
import React from 'react';
import {
  Typography,
  Box,
  Grid,
  Paper,
  Stack
} from "@mui/material";
import { styled } from '@mui/material/styles';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import GroupsIcon from '@mui/icons-material/Groups';
import StarIcon from '@mui/icons-material/Star';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import ScheduleIcon from '@mui/icons-material/Schedule';
import BadgeIcon from '@mui/icons-material/Badge';
import dayjs from 'dayjs';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const ServiceBadge = styled(Box)(({ theme }) => ({
  display: 'inline-block',
  padding: '6px 16px',
  borderRadius: '999px',
  backgroundColor: 'rgba(47, 107, 255, 0.1)',
  color: '#2f6bff',
  fontWeight: 700,
  fontSize: '0.85rem',
  border: '1px solid rgba(47, 107, 255, 0.2)',
  boxShadow: '0 2px 8px rgba(47, 107, 255, 0.1)'
}));

const styledLabel = {
  color: '#94a3b8',
  display: 'block',
  fontSize: '0.65rem',
  lineHeight: 1.1,
  mb: 0.25,
  textTransform: 'uppercase',
  letterSpacing: 0.5,
  fontWeight: 600
};

const CompactWorkCard = ({ icon, label, value, color = "#2f6bff" }) => (
  <Paper
    elevation={0}
    sx={{
      p: { xs: 1.5, sm: 1.75 },
      borderRadius: '16px',
      border: '1px solid #eef0f4',
      height: '100%',
      transition: 'all 0.2s ease',
      '&:hover': {
        borderColor: `${color}40`,
        transform: 'translateY(-2px)',
        boxShadow: `0 6px 18px ${color}14`
      }
    }}
  >
    <Stack direction="row" spacing={1.25} alignItems="center">
      <Box sx={{
        width: 38,
        height: 38,
        borderRadius: '12px',
        backgroundColor: `${color}14`,
        color: color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 38,
      }}>
        {React.cloneElement(icon, { sx: { fontSize: 17 } })}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="caption" sx={styledLabel}>
          {label}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: '#1e293b',
            fontSize: '0.825rem',
            lineHeight: 1.3,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          {value || "Not Assigned"}
        </Typography>
      </Box>
    </Stack>
  </Paper>
);

const EmpWrkDetails = ({ data }) => {


  const calculateService = (doj) => {
    if (!doj) return 'N/A';
    const start = dayjs(doj);
    const now = dayjs();
    const years = now.diff(start, 'year');
    const months = now.diff(start, 'month') % 12;
    return `${years} Years, ${months} Months`;
  };

  const workInfo = [
    { icon: <CalendarMonthIcon />, label: "Date of Joining", value: data?.date_of_joining, color: "#2f6bff" },
    { icon: <CalendarMonthIcon />, label: "Confirmation Date", value: data?.confirmation_date, color: "#2f6bff" },
    { icon: <GroupsIcon />, label: "Department", value: data?.department, color: "#2f6bff" },
    { icon: <BusinessCenterIcon />, label: "Designation", value: data?.designation, color: "#2f6bff" },
    { icon: <SupervisorAccountIcon />, label: "Reporting Manager", value: data?.reporting_manager, color: "#2f6bff" },
    { icon: <LocationOnIcon />, label: "Branch", value: data?.branch_name, color: "#2f6bff" },
    { icon: <ScheduleIcon />, label: "Attendance Schema", value: data?.attendance_schema, color: "#2f6bff" },
    { icon: <BadgeIcon />, label: "Division", value: data?.division, color: "#2f6bff" },
    { icon: <StarIcon />, label: "Grade", value: data?.grade, color: "#2f6bff" },
  ];

  return (
    <Box>
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'flex-end' }}>
        <ServiceBadge>
          Tenure: {calculateService(data?.date_of_joining)}
        </ServiceBadge>
      </Box>
      <Grid container spacing={1.5}>
        {workInfo.map((info, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <CompactWorkCard {...info} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default EmpWrkDetails;